import {createSelector} from 'reselect';
import {
  getSelectedDeliveryOptionIDList,
} from '../DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import getPaymentMessageByDeliveryOption from '../../../sections/PaymentOptionsSection/PaymentOptions/getPaymentMessageByDeliveryOption';

export default paymentType => createSelector(
  [getSelectedDeliveryOptionIDList],
  deliveryOptionIdList => getPaymentMessageByDeliveryOption(deliveryOptionIdList, paymentType),
);
